window.NRIForm = class {
  constructor(formElement, formType) {
    this.form = document.querySelector(formElement);
    if (!this.form) {
      console.error("Form element not found.");
      return;
    }

    // variables
    this.formValid = true;
    this.formId = this.form.id;
    this.formType = formType;
    this.submitButton = null;
    this.submitHandler = null;
    this.hasTouched = false;
    this.HsPortalId = "43974469";
    this.HsFormId = "";
    this.requiredFields = this.form.querySelectorAll("[aria-required]");

    switch (this.formType) {
      // Demo and premium form are essentially the same, but for 1 field
      case "premium":
        this.HsFormId = "74b8ad65-7cd0-4827-bca5-b67396914eec";
        this.submitHandler = this.submitPremiumForm;
        // Fetch the user data for the prefill
        this.userDataEndpoint =
          window.location.origin + "/premium_applications/api/new?pardot=true";
        // Handle testing of prefilled data from fakePremiumResponse
        if (
          window.location.href.includes("http://noredink.local/") ||
          window.location.origin.includes("cloudwaysapps")
        ) {
          this.userDataEndpoint = "";
        }

        this.firstSubmitCompleted = false;
        this.handlePremiumForm();
        break;
      case "demo":
        this.HsFormId = "364d3910-a1d4-40dd-8a63-2da81da24851";
        this.submitHandler = this.submitDemoForm;
        this.userDataEndpoint =
          window.location.origin + "/premium_applications/api/new?pardot=true";
        // Handle testing of prefilled data from fakePremiumResponse
        if (
          window.location.href.includes("http://noredink.local/") ||
          window.location.origin.includes("cloudwaysapps")
        ) {
          this.userDataEndpoint = "";
        }

        this.firstSubmitCompleted = false;
        this.handlePremiumForm();
        break;
      case "signup":
        this.initSignupForm();
        break;
      default:
        break;
    }

    this.initValidation();

    // Submit
    if (this.formType == "premium" || this.formType == "demo") {
      this.submitButton = this.form.querySelector('[type="submit"]');
      this.falseSubmit = this.form.querySelector(".false-submit");
      this.recaptchaBtn = document.querySelector("#nri-recaptcha");

      if (!this.formValid) {
        this.submitButton.setAttribute("aria-invalid", !this.formValid);
        this.submitButton.setAttribute("disabled", !this.formValid);
      }

      // false submit handles validation and clicks the recaptcha button
      this.falseSubmit.addEventListener("click", (e) => {
        e.preventDefault();
        this.validateForm();
        if (this.formValid) {
          if (window.location.href.includes("http://noredink.local/")) {
            this.submitButton.removeAttribute("disabled");
            this.submitButton.click();
            this.submitButton.setAttribute("disabled", true);
          } else {
            this.recaptchaBtn.click();
          }
        }
      });

      // recaptcha script is in demo-form.php

      // submit button handles the form submission to pardot
      this.submitButton.addEventListener("click", (e) => {
        e.preventDefault();
        if (this.formValid) {
          this.falseSubmit.classList.add("disabled");
          this.falseSubmit.setAttribute("aria-invalid", !this.formValid);
          this.falseSubmit.setAttribute("disabled", !this.formValid);
          // @ts-ignore
          this.submitHandler();
        }
      });
    }

    this.MONOLITH_POST_ENDPOINT = `${window.location.origin}/premium_applications/`;
    this.HUBSPOT_POST_ENDPOINT = `https://api.hsforms.com/submissions/v3/integration/submit/${this.HsPortalId}/${this.HsFormId}`;
  }

  getHSUTK() {
    const utk = "hubspotutk=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(utk) === 0) return c.substring(utk.length, c.length);
    }
    return null;
  }

  handlePremiumForm() {
    this.gradeCheckboxData = [];
    this.initPremium();
    this.handleSchoolSearch();
    this.initPremiumCheckboxes();
    this.initPremiumModal(this.formType);
    this.handleSchoolRole();
    this.handleFirstTouch();
  }

  handleFirstTouch() {
    // @ts-ignore
    this.form.addEventListener("focusin", (e) => {
      if (!this.hasTouched) {
        this.hasTouched = true;
        this.formEvent(
          this.formType == "premium"
            ? "Started Premium Application Form"
            : "PremiumDistrict_GetADemo_FormStarted"
        );
      }
    });
  }

  handleSchoolSearch() {
    // DOM Manipulation to get the dropdown to display in and out;
    // Some A11y concerns here, the elements are not keyboard-focusable
    /** @type {HTMLInputElement} */
    const inputField = this.form.querySelector('[name="company"]');
    /** @type {HTMLUListElement} */
    const listBox = this.form.querySelector(
      "#nri-input-menu-listbox---school-or-district-name"
    );

    inputField.addEventListener("input", async () => {
      if (!inputField.value) {
        listBox.style.display = "none";
      } else {
        listBox.style.display = "block";
      }
    });
    inputField.addEventListener("focusout", () => {
      // To allow for the user click on any option to fire
      setTimeout(() => (listBox.style.display = "none"), 200);
    });
  }

  // PREMIUM
  initPremium() {
    // meta tags testing
    let csrfToken = document.querySelector("meta[name=csrf-token]");
    let csrfParam = document.querySelector("meta[name=csrf-param]");

    if (!csrfToken && window.location.href.includes("http://noredink.local/")) {
      const csrfTokenMeta = document.createElement("meta");
      csrfTokenMeta.name = "csrf-token";
      csrfTokenMeta.content = "1234567890";
      document.head.appendChild(csrfTokenMeta);
      csrfToken = csrfTokenMeta;
    }
    if (!csrfParam && window.location.href.includes("http://noredink.local/")) {
      const csrfParamMeta = document.createElement("meta");
      csrfParamMeta.name = "csrf-param";
      csrfParamMeta.content = "authenticity_token";
      document.head.appendChild(csrfParamMeta);
      csrfParam = csrfParamMeta;
    }

    // Pardot init
    // @ts-ignore
    fetch(this.userDataEndpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        // @ts-ignore
        "X-CSRF-Token": csrfToken?.getAttribute("content"),
      },
    })
      .then((response) => {
        if (response) {
          // local and cloudways
          if (
            window.location.href.includes("http://noredink.local/") ||
            window.location.origin.includes("cloudwaysapps")
          ) {
            this.initForm(fakePremiumResponse);

            // staging and live
          } else {
            response.json().then((json) => {
              this.initForm(json);
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  initForm(data) {
    this.premiumFormData = data;

    if (
      !window.location.href.includes("http://noredink.local/") &&
      "ld_bookit_calendar_link" in this.premiumFormData.premium_application &&
      this.premiumFormData.premium_application.ld_bookit_calendar_link != null
    ) {
      this.displayPremiumComplete(
        this.premiumFormData.premium_application.ld_bookit_calendar_link,
        false
      );
      return;
    }

    // second endpoint
    this.formSubmitEndpoint = data.form_submit_path;

    // prefill form
    const roleSelect = this.form.querySelector('[name="role__c"]');

    const enrollmentRangeSelect = this.form.querySelector(
      '[name="PA Enrollment Range"]'
    );

    const firstNameInput = this.form.querySelector('[name="firstname"]');
    const lastNameInput = this.form.querySelector('[name="lastname"]');
    const emailInput = this.form.querySelector('[name="email"]');
    const phoneInput = this.form.querySelector('[name="phone"]');
    const stateSelect = this.form.querySelector('[name="state_region"]');
    const schoolInput = this.form.querySelector('[name="company"]');
    const gradesFieldset = this.form.querySelector(".inputs-list");
    const nriUserIdInput = this.form.querySelector('[name="noredink_user_id"]');
    const schoolIdInput = this.form.querySelector('[name="school_id"]');

    const userData = this.premiumFormData.premium_application;

    if (roleSelect && userData.role != null) {
      roleSelect.value = userData.role;
      if (typeof userData.role === "number") {
        const roleLabel = MONOLITH_ROLES.find(
          (role) => role.value == userData.role
        )?.label;
        /** @type {HTMLOptionElement} */
        const roleOption = roleSelect.querySelector(`[value="${roleLabel}"`);
        if (roleOption) {
          roleOption.selected = true;
        }
      }
    }

    if (enrollmentRangeSelect && userData.enrollment_range != null) {
      enrollmentRangeSelect.value = userData.enrollment_range;
    }
    if (firstNameInput && userData.first_name) {
      firstNameInput.value = userData.first_name;
    }
    if (lastNameInput && userData.last_name) {
      lastNameInput.value = userData.last_name;
    }
    if (emailInput && userData.email) {
      emailInput.value = userData.email;
    }
    if (phoneInput && userData.phone_number) {
      phoneInput.value = userData.phone_number;
    }
    if (stateSelect && userData.state) {
      stateSelect.value = userData.state;
    }
    if (schoolInput && userData.school) {
      schoolInput.value = userData.school;
    }
    if (schoolInput && userData.school_id) {
      schoolInput.dataset.schoolId = userData.school_id;
    }
    if (schoolIdInput && userData.school_id) {
      schoolIdInput.value = userData.school_id;
    }
    if (gradesFieldset && userData.grades) {
      userData.grades.forEach((grade) => {
        const gradeCheckbox = gradesFieldset.querySelector(
          `[value="${grade}"]`
        );
        if (gradeCheckbox) {
          gradeCheckbox.click();
        }
      });
    }
    if (nriUserIdInput && userData.user_id) {
      nriUserIdInput.value = userData.user_id;
    }
  }

  initPremiumModal() {
    const formSlug =
      this.formType == "premium" ? "premium-application" : "get-a-demo-form";
    this.premiumFormSection = document.querySelector(
      '[data-premium-form-wrap-id="' + formSlug + '"]'
    );
    this.premiumCompleteSection = document.querySelector(
      '[data-premium-complete-wrap-id="' + formSlug + '"]'
    );
    this.calendarModal = document.querySelector(
      '[data-calendar-modal-id="' + formSlug + '"]'
    );
    this.calendarModalButton =
      this.premiumCompleteSection.querySelector(".btn-find-a-time");
    this.calendarModalCloseButton =
      this.calendarModal.querySelector(".btn-close-modal");

    document.body.appendChild(this.calendarModal);

    this.calendarModalButton.addEventListener("click", () => {
      this.formEvent(
        this.formType == "premium"
          ? "PremiumApplication_CalendarModal_Opened"
          : "PremiumDistrict_CalendarModal_Opened"
      );
      this.calendarModal.classList.remove("hidden");
      document.querySelector("html").style.overflowY = "hidden";
    });
    this.calendarModalCloseButton.addEventListener("click", () => {
      this.formEvent(
        this.formType == "premium"
          ? "PremiumApplication_CalendarModal_Closed"
          : "PremiumDistrict_CalendarModal_Closed"
      );
      this.calendarModal.classList.add("hidden");
      document.querySelector("html").style.overflowY = "unset";
    });
  }

  displayPremiumComplete(calendarLink, popup = true) {
    this.premiumFormSection.classList.add("hidden");
    this.premiumCompleteSection.classList.remove("hidden");

    if (
      calendarLink != null &&
      calendarLink != "https://noop.dontchangeunlessyouknowwhatyouaredoing"
    ) {
      this.calendarModalButton.classList.remove("hidden");
      const iframe = this.calendarModal.querySelector(
        "#premium-application-scheduling-container iframe"
      );
      iframe.src = calendarLink;
      if (popup) this.calendarModalButton.click();
    } else {
      this.calendarModalButton.classList.add("hidden");
    }
  }

  initPremiumCheckboxes() {
    const checkboxes = document.querySelectorAll(
      '#premium-application-grades input[type="checkbox"]'
    );
    let selectedValues = [];

    const checkTheCheckBoxes = (checkbox) => {
      // @ts-ignore
      if (checkbox.checked) {
        // @ts-ignore
        selectedValues.push(checkbox.value);
      } else {
        const index = this.gradeCheckboxData.indexOf(checkbox.value);
        if (index > -1) {
          this.gradeCheckboxData.splice(index, 1);
        }
      }
      this.gradeCheckboxData = selectedValues;
    };

    checkboxes.forEach((checkbox) => {
      checkTheCheckBoxes(checkbox);
      checkbox.addEventListener("change", () => {
        checkTheCheckBoxes(checkbox);
        this.validateCheckboxes();
      });
    });
  }

  handleSchoolRole() {
    const roleSelect = this.form.querySelector('[name="role__c"');
    const roleError = document.querySelector("#role-error-demo-premium");
    const mainField = this.form.querySelectorAll(".main-field");

    roleSelect.addEventListener("change", () => {
      if (roleSelect.value === "PARENT_OR_HOMESCHOOLING") {
        // @ts-ignore
        roleError.classList.remove("hidden");
        mainField.forEach((el) => el.classList.add("hidden"));
      } else {
        // @ts-ignore
        roleError.classList.add("hidden");
        mainField.forEach((el) => el.classList.remove("hidden"));
      }
    });
  }
  /** @param {'demo' | 'premium'} type */
  #parseDataForEndpoints(type) {
    // Create FormData that we'll send
    const formData = new FormData(this.form);
    // Use previously stored info to get user and calendar values
    const ld_calendar_link = window.localStorage.getItem(
      "LDCalendaring_hubspot_calendarLink"
    );
    const ld_form_input = window.localStorage.getItem(
      "LDCalendaring_hubspot_formInput"
    );
    const ld_log_id = ld_form_input
      ? JSON.parse(ld_form_input).LD_BookIt_Log_ID__c
      : null;
    const user_id =
      this.premiumFormData?.premium_application?.user_id ||
      window.localStorage.getItem("ajs_user_id") ||
      null;
    const district_id =
      this.premiumFormData?.premium_application?.district_id || null;
    const school_id =
      this.form.querySelector('[name="company"')?.dataset.schoolId || "";
    // Create data object
    const data = {
      user_id: user_id ? user_id.toString() : null,
      email: formData.get("email"),
      first_name: formData.get("firstname"),
      last_name: formData.get("lastname"),
      phone_number: formData.get("phone"),
      role: formData.get("role__c"),
      school: formData.get("company"),
      state: formData.get("state_region"),
      grades: this.gradeCheckboxData,
      district_id: district_id,
      ld_bookit_calendar_link: ld_calendar_link,
      ld_bookit_log_id: ld_log_id,
      school_id: school_id,
    };
    // Create HS Data object
    const hubspotData = {
      fields: [
        {
          objectTypeId: "0-1",
          name: "email",
          value: data.email,
        },
        {
          objectTypeId: "0-1",
          name: "firstname",
          value: data.first_name,
        },
        {
          objectTypeId: "0-1",
          name: "lastname",
          value: data.last_name,
        },
        {
          objectTypeId: "0-1",
          name: "company",
          value: data.school,
        },
        {
          objectTypeId: "0-1",
          name: "role__c",
          value: data.role,
        },
        {
          objectTypeId: "0-1",
          name: "phone",
          value: data.phone_number,
        },
        {
          objectTypeId: "0-1",
          name: "state_region",
          value: data.state,
        },
        {
          objectTypeId: "0-1",
          name: "grades__c",
          value: data.grades.join(";") || "", // HS requires multicheckboxes to be semicolon-separated strings
        },
        {
          objectTypeId: "0-1",
          name: "noredink_user_id",
          value: data.user_id,
        },
        {
          objectTypeId: "0-1",
          name: "school_id",
          value: data.school_id,
        },
        {
          objectTypeId: "0-1",
          name: "ld_bookit_log_id__c",
          value: data.ld_bookit_log_id,
        },
        {
          objectTypeId: "0-1",
          name: "ld_bookit_calendar_link",
          value: data.ld_bookit_calendar_link,
        },
      ],
      ipAddress: "",
      context: {
        hutk: this.getHSUTK(),
      },
    };
    // Account for PA_Enrollment_range value in premium forms
    if (type === "premium") {
      data.enrollment_range = formData.get("pa_enrollment_range__c");
      const enrollment_hs = {
        objectTypeId: "0-1",
        name: "pa_enrollment_range__c",
        value: data.enrollment_range,
      };
      hubspotData.fields.push(enrollment_hs);
    }

    // Map role for monolith value
    const roleAsNumber =
      MONOLITH_ROLES.find((role) => role.label === data.role)?.value || 11; // Defaults to 'Other'
    data.role = roleAsNumber;

    return {
      hubspot: hubspotData,
      monolith: {
        premium_application: data,
        school_id: school_id || "",
        pardot_submit_form_url:
          this.formType === "premium"
            ? null
            : "https://go.noredink.com/l/878882/2023-09-13/ypld2",
      },
    };
  }

  #addCalendarOptions() {
    // TODO: Calendar scheduling
  }

  submitPremiumForm() {
    const { monolith } = this.#parseDataForEndpoints();
    // @ts-ignore
    const csrfToken = document
      .querySelector("meta[name=csrf-token]")
      .getAttribute("content");

    // Submit form to monolith
    this.formEvent("PremiumApplication_Form_Submitted");

    // Wrap post calls to both endpoints
    fetch(this.MONOLITH_POST_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify(monolith),
    })
      .then((response) => {})
      .catch((error) => {
        console.error(error);
      });

    window.addEventListener("message", (event) => {
      if (event?.data?.eventName == "onFormSubmitted") {
        this.falseSubmit.classList.remove("disabled");
        this.falseSubmit.setAttribute("aria-invalid", !this.formValid);
        this.falseSubmit.setAttribute("disabled", !this.formValid);

        this.formEvent("PremiumApplication_Form_SubmitSuccess");
        const calendarLink = localStorage.getItem(
          "LDCalendaring_hubspot_calendarLink"
        );
        this.displayPremiumComplete(calendarLink);
      }
    });
  }

  submitDemoForm() {
    const { monolith } = this.#parseDataForEndpoints("demo");
    // @ts-ignore
    const csrfToken = document
      .querySelector("meta[name=csrf-token]")
      .getAttribute("content");

    // Submit form to hubspot/monolith
    this.formEvent("PremiumDistrict_GetADemo_FormSubmitted");

    fetch(this.MONOLITH_POST_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify(monolith),
    })
      .then((response) => {})
      .catch((error) => {
        console.error(error);
      });

    window.addEventListener("message", (event) => {
      if (event?.data?.eventName == "onFormSubmitted") {
        this.falseSubmit.classList.remove("disabled");
        this.falseSubmit.setAttribute("aria-invalid", !this.formValid);
        this.falseSubmit.setAttribute("disabled", !this.formValid);

        const calendarLink = localStorage.getItem(
          "LDCalendaring_hubspot_calendarLink"
        );
        this.formEvent("PremiumDistrict_GetADemo_SubmitSuccess");
        this.displayPremiumComplete(calendarLink);
      }
    });
  }

  // SIGNUP
  initSignupForm() {
    // set temp data
    if (location.href.includes("http://noredink.local/")) {
      // @ts-ignore
      window.BROWSER_FLAGS = JSON.parse(`
        {"v1":
          {
            "googleSSOEnabled":true,
            "classLinkEnabled":true,
            "cleverURL":"https://clever.com/oauth/authorize?client_id=831ad05418aa114dea2a&redirect_uri=https%3A%2F%2Fwww.noredink.com%2Fauth%2Fclever%2Fcallback&response_type=code&state=%7B%22csrf_token%22%3A%22Q886dVWNFL1SynwQ4l7B3No4rjRzSzCApRhITRxqsgkMA8hSFkWBxoPL1NThS%2B3FeW5vRSEqpJkW5vW9oFLGaw%3D%3D%22%2C%22via_nri%22%3Atrue%7D",
            "classLinkURL":"https://launchpad.classlink.com/oauth2/v2/auth?client_id=c1657744637172245f324510510799ebf449661bce62&redirect_uri=https%3A%2F%2Fwww.noredink.com%2Fclasslink%2Fredirect&response_type=code&scope=full%2Cprofile%2Coneroster%2Copenid&state=%7B%22csrf_token%22%3A%22VsGcHi5fa4EZg8YDHk48kEZYY1bizhgJs2whKmq6ZVAZDW45bZf%2B%2BsiCbscdWxCJ5Q6iJ7CvjBAAkpza1oIRMg%3D%3D%22%2C%22intent%22%3A%22login%22%7D",
            "passwordGuidance":"Passwords must be at least 8 characters long.",
            "flash":{"notice":[],
            "warning":[],
            "error":[]},
            "enableRedirectAfterLogin":false,
            "enableCustomJavascript":false,
            "enableProductForDistrictsNavbarMenu":true,
            "enableDistrictResourceCenterNavbarMenu":false,
            "enableUpdatedMarketingSiteNavbar":false,
            "googleSignUpUrl": "https://staging.noredink.com/auth/google/signup"
          }
        }`);
    }

    const cleverBtn = this.form.querySelector("#sign_up_with_clever");
    const googleBtn = this.form.querySelector("#sign_up_with_google");
    const classlinkBtn = this.form.querySelector("#sign_up_with_classlink");

    // @ts-ignore
    if (window.BROWSER_FLAGS.v1.cleverURL) {
      cleverBtn.addEventListener("click", () => {
        // @ts-ignore
        window.location.href = window.BROWSER_FLAGS.v1.cleverURL;
      });
    }
    // @ts-ignore
    if (window.BROWSER_FLAGS.v1.googleSSOEnabled) {
      googleBtn.addEventListener("click", () => {
        // @ts-ignore
        window.location.href = window.BROWSER_FLAGS.v1.googleSignUpUrl;
        // TEMPORARY FIX FOR GOOGLE SSO
        // window.location.href = "/signup";
      });
    } else {
      googleBtn.classList.add("hidden");
    }
    // @ts-ignore
    if (window.BROWSER_FLAGS.v1.classLinkEnabled) {
      classlinkBtn.addEventListener("click", () => {
        // @ts-ignore
        window.location.href = window.BROWSER_FLAGS.v1.classLinkURL;
      });
    } else {
      classlinkBtn.classList.add("hidden");
    }
  }

  // VALIDATION
  initValidation() {
    this.requiredFields.forEach((field) => {
      let eventInput = field.tagName === "SELECT" ? "change" : "blur";
      field.addEventListener(eventInput, () => {
        setTimeout(() => {
          this.validateField(field);
        }, 5);
      });
    });
  }

  validateForm() {
    // reset form
    this.formValid = true;

    this.requiredFields.forEach((field) => {
      this.validateField(field);
    });

    this.validateCheckboxes();

    this.submitButton.setAttribute("aria-invalid", !this.formValid);
    this.submitButton.setAttribute("disabled", !this.formValid);
  }

  validateField(field) {
    // handle Homeschool option
    const schoolInput = field.id === `company-${this.HsFormId}`;
    if (schoolInput) {
      const homeschool = this.handleHomeSchool(field);
      if (homeschool) return;
    }

    // handle phone number
    if (field.type === "tel") {
      const valueDigits = field.value.replace(/\D/g, "");
      if (
        valueDigits.length < 10 ||
        valueDigits.length > 11 ||
        (valueDigits.length === 11 && valueDigits[0] !== "1")
      ) {
        this.displayErrorTip(field);
        this.formValid = false;
        return false;
      }
      if (
        valueDigits.length === 10 ||
        (valueDigits.length === 11 && valueDigits[0] === "1")
      ) {
        this.removeErrorTip(field);
      }
      return true;
    }

    // handle email
    if (field.type === "email") {
      if (!field.value || field.classList.contains("invalid")) {
        this.displayErrorTip(field);
        this.formValid = false;
        console.error("Invalid email", field.value);
        return false;
      }
      this.removeErrorTip(field);
      return true;
    }

    // Validate state filling on school autocomplete
    setInterval(() => {
      if (field.name === "state_region" && !!field.value) {
        this.removeErrorTip(field);
      }
    }, 100);
    if (
      !field.value ||
      field.value === "Select a state" ||
      field.value === "Select a role" ||
      field.value === "Select a range"
    ) {
      this.displayErrorTip(field);
      this.formValid = false;
      return false;
    } else {
      this.removeErrorTip(field);
    }
    return true;
  }

  validateCheckboxes() {
    const field = this.form.querySelector(".inputs-list");
    if (this.gradeCheckboxData?.length === 0) {
      this.displayErrorTip(field, true);
      this.formValid = false;
    } else {
      this.removeErrorTip(field, true);
    }
  }

  removeErrorTip(field, checkbox = false) {
    const inputWrap = field.closest(".field");
    if (!document.querySelector("#" + field.dataset.errorMessageId)) return;
    inputWrap.classList.remove("error");
    const errorMessage = document.getElementById(field.dataset.errorMessageId);
    if (!errorMessage) return;
    errorMessage.remove();
    field.removeAttribute("aria-describedby");
  }

  displayErrorTip(field, checkbox = false) {
    const inputWrap = field.closest(".field");
    if (document.querySelector("#" + field.dataset.errorMessageId)) return;
    inputWrap.classList.add("error");
    const errorMessage = document.createElement("div");
    errorMessage.setAttribute("id", field.dataset.errorMessageId);
    errorMessage.classList.add("error-message", "pvxxs");
    errorMessage.innerHTML = `
				<div class="flex items-center gap-xxs">
						<svg viewBox="0 0 20 20" fill="currentcolor" role="img" focusable="false"><title>Error</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-0.000000, 0.000000)"><circle cx="10" cy="10" r="10" fill="currentcolor"></circle><g transform="translate(8.076923, 3.999920)" fill="#FFFFFF" fill-rule="nonzero"><ellipse cx="1.93846154" cy="10.9680805" rx="1.35384615" ry="1.368"></ellipse><path d="M1.97692308,8.8817842e-16 L1.90769231,8.8817842e-16 C0.885965773,-0.00943548878 0.0414942946,0.826318865 0,1.88808046 C0,2.33608046 0.846153846,7.55208046 0.846153846,7.55208046 C0.936885659,8.09472815 1.39352824,8.48822359 1.92307692,8.48008046 L1.96923077,8.48008046 C2.49877945,8.48822359 2.95542203,8.09472815 3.04615385,7.55208046 C3.04615385,7.55208046 3.84615385,2.34408046 3.84615385,1.88808046 C3.80528838,0.841775663 2.9837499,0.0119879899 1.97692308,8.8817842e-16 Z"></path></g></g></g></svg>
						<span>${field.dataset.errorMessage}</span>
				</div>
		`;
    if (!checkbox) {
      inputWrap.appendChild(errorMessage);
    } else {
      inputWrap.parentNode.insertBefore(
        errorMessage,
        inputWrap.nextElementSibling
      );
    }
    field.setAttribute("aria-describedby", errorMessage.id);
  }

  handleHomeSchool(schoolInput) {
    if (!schoolInput) return false;

    const homeschoolError = this.form.querySelector(".homeschool-error");
    homeschoolError.classList.add("hidden");

    const schoolInputValueTreated = schoolInput.value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]/g, "");
    if (schoolInputValueTreated.includes("homeschool")) {
      this.formValid = false;
      homeschoolError.classList.remove("hidden");
      schoolInput.closest(".input-wrap")?.classList.add("error");
      return true;
    }
    return false;
  }

  formEvent(l) {
    // @ts-ignore
    if (window.gtag) {
      // @ts-ignore
      gtag("event", l);
    }
  }
};

///////// Fake Premium Response
const fakePremiumResponse = {
  premium_application: {
    user_id: 33281821,
    email: "test@email.com",
    first_name: "TEST",
    last_name: "TEST",
    phone_number: "1234567890",
    role: 0,
    grades: ["Grades 9-12"],
    school: "",
    school_id: 0,
    district_id: "3702970",
    state: "",
    ld_bookit_calendar_link:
      "https://app.leandata.com/v2/schedule?link=thnCh9LE78VtFRhXIdE5QzhWOWhPc24qaLQnp6q33pTMtDuWSxFeoMn59QhJsYrM23Y2WmCAS1STmVqm8xeSWjyulqM2WX6AOyoAnC%2BxRQ1QnjIkavuwj0VxY9D9hodYPgQFyrsRvR8s41uEUwYW6izrmFgj24e8530vGxs6Hh7bbB%2BPgakELknYo8O526uor56ZHVWAq%2BvIYgbt8Ho1miBbF6WqamryDT4ugVcUCDCkdUZk9n%2FxX9PAMspYOw23IHTAO6ibbCFCMpbFFDJav2BW6EupzVtNDLls8djaDNbVSnXjk0544HrIyR7meTL4X4BkEX2Z72K7Q57pA87gM7M2488RxununZY1NsngZ%2FkgILd61r%2BuM2YPe4XhTN0CD3A2cMQnv4PTeKz%2FVDTthZy5W%2FhMHxm2aZsrofICt1xqr%2F%2Bu8NkZKQf%2F77t%2FvR6ziziqkLWlXmhrvbRvB0uY3sNm9IQFR%2BLJ%2BPUzyO7SlUs4QQf44t1y5uCsUnhEVbd55ddjDcDQa4CEpMqSgrVdCBzLWxZx%2BqP6UjOHeQg%2Fcd5cc1bdAguzc2DIu2ISyTgT\u0026fallback_url=https%3A%2F%2Fwww.noredink.com\u0026vars=eyJFbWFpbCI6Im5rZW5uZWR5MTAyN0BnbWFpbC5jb20iLCJQaG9uZSI6IjcwNDk2MjcxMzIiLCJTdGF0ZSI6Ik5vcnRoIENhcm9saW5hIiwiU2Nob29sIG9yIERpc3RyaWN0IjoiTWF0dGhld3MgRWxlbWVudGFyeSIsIlJvbGUiOiJUZWFjaGVyIiwiR3JhZGVzIjpbIkdyYWRlcyAzLTUiLCJHcmFkZXMgNi04IiwiR3JhZGVzIDktMTIiXX0=",
    ld_bookit_log_id: null,
  },
  form_submit_path:
    "https://api.hsforms.com/submissions/v3/integration/submit/43974469/364d3910-a1d4-40dd-8a63-2da81da24851",
  roles: [
    {
      label: "Teacher",
      value: 0,
    },
    {
      label: "Instructional Coach",
      value: 1,
    },
    {
      label: "Department Chair",
      value: 2,
    },
    {
      label: "Curriculum Coordinator",
      value: 3,
    },
    {
      label: "Tech Coordinator",
      value: 4,
    },
    {
      label: "Librarian",
      value: 5,
    },
    {
      label: "Assistant Principal",
      value: 6,
    },
    {
      label: "Principal",
      value: 7,
    },
    {
      label: "Associate Superintendent",
      value: 8,
    },
    {
      label: "Superintendent",
      value: 9,
    },
    {
      label: "ELA specialist",
      value: 12,
    },
    {
      label: "Other District-Level Administrator",
      value: 10,
    },
    {
      label: "Other",
      value: 11,
    },
  ],
  states: [
    {
      label: "Alabama",
      value: "AL",
    },
    {
      label: "Alaska",
      value: "AK",
    },
    {
      label: "Arizona",
      value: "AZ",
    },
    {
      label: "Arkansas",
      value: "AR",
    },
    {
      label: "California",
      value: "CA",
    },
    {
      label: "Colorado",
      value: "CO",
    },
    {
      label: "Connecticut",
      value: "CT",
    },
    {
      label: "Delaware",
      value: "DE",
    },
    {
      label: "Florida",
      value: "FL",
    },
    {
      label: "Georgia",
      value: "GA",
    },
    {
      label: "Hawaii",
      value: "HI",
    },
    {
      label: "Idaho",
      value: "ID",
    },
    {
      label: "Illinois",
      value: "IL",
    },
    {
      label: "Indiana",
      value: "IN",
    },
    {
      label: "Iowa",
      value: "IA",
    },
    {
      label: "Kansas",
      value: "KS",
    },
    {
      label: "Kentucky",
      value: "KY",
    },
    {
      label: "Louisiana",
      value: "LA",
    },
    {
      label: "Maine",
      value: "ME",
    },
    {
      label: "Maryland",
      value: "MD",
    },
    {
      label: "Massachusetts",
      value: "MA",
    },
    {
      label: "Michigan",
      value: "MI",
    },
    {
      label: "Minnesota",
      value: "MN",
    },
    {
      label: "Mississippi",
      value: "MS",
    },
    {
      label: "Missouri",
      value: "MO",
    },
    {
      label: "Montana",
      value: "MT",
    },
    {
      label: "Nebraska",
      value: "NE",
    },
    {
      label: "Nevada",
      value: "NV",
    },
    {
      label: "New Hampshire",
      value: "NH",
    },
    {
      label: "New Jersey",
      value: "NJ",
    },
    {
      label: "New Mexico",
      value: "NM",
    },
    {
      label: "New York",
      value: "NY",
    },
    {
      label: "North Carolina",
      value: "NC",
    },
    {
      label: "North Dakota",
      value: "ND",
    },
    {
      label: "Ohio",
      value: "OH",
    },
    {
      label: "Oklahoma",
      value: "OK",
    },
    {
      label: "Oregon",
      value: "OR",
    },
    {
      label: "Pennsylvania",
      value: "PA",
    },
    {
      label: "Rhode Island",
      value: "RI",
    },
    {
      label: "South Carolina",
      value: "SC",
    },
    {
      label: "South Dakota",
      value: "SD",
    },
    {
      label: "Tennessee",
      value: "TN",
    },
    {
      label: "Texas",
      value: "TX",
    },
    {
      label: "Utah",
      value: "UT",
    },
    {
      label: "Vermont",
      value: "VT",
    },
    {
      label: "Virginia",
      value: "VA",
    },
    {
      label: "Washington",
      value: "WA",
    },
    {
      label: "West Virginia",
      value: "WV",
    },
    {
      label: "Wisconsin",
      value: "WI",
    },
    {
      label: "Wyoming",
      value: "WY",
    },
    {
      label: "District of Columbia",
      value: "DC",
    },
    {
      label: "American Samoa",
      value: "AS",
    },
    {
      label: "Federated States of Micronesia",
      value: "FM",
    },
    {
      label: "Guam",
      value: "GU",
    },
    {
      label: "Marshall Islands",
      value: "MH",
    },
    {
      label: "Northern Mariana Islands",
      value: "MP",
    },
    {
      label: "Palau",
      value: "PW",
    },
    {
      label: "Puerto Rico",
      value: "PR",
    },
    {
      label: "Virgin Islands",
      value: "VI",
    },
    {
      label: "International",
      value: "International",
    },
  ],
};

const MONOLITH_ROLES = [
  {
    label: "Teacher",
    value: 0,
  },
  {
    label: "Instructional Coach",
    value: 1,
  },
  {
    label: "Department Chair",
    value: 2,
  },
  {
    label: "Curriculum Coordinator",
    value: 3,
  },
  {
    label: "Tech Coordinator",
    value: 4,
  },
  {
    label: "Librarian",
    value: 5,
  },
  {
    label: "Assistant Principal",
    value: 6,
  },
  {
    label: "Principal",
    value: 7,
  },
  {
    label: "Associate Superintendent",
    value: 8,
  },
  {
    label: "Superintendent",
    value: 9,
  },
  {
    label: "ELA specialist",
    value: 12,
  },
  {
    label: "Other District-Level Administrator",
    value: 10,
  },
  {
    label: "Other",
    value: 11,
  },
];
